import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import CollectionsIcon from '@mui/icons-material/Collections';
import BlockIcon from '@mui/icons-material/Block';
import NiceDate from "../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect,useMemo } from 'react';
import { getSigns } from "../../slices/sign";
import { getUser } from "../../slices/user";
import ProfileAvatar from "../../components/user/ProfileAvatar";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import NiceCollection from "../../components/global/NiceCollection";
import NiceSignMode from "../../components/global/NiceSignMode";
import NiceSignBrightness from "../../components/global/NiceSignBrightness";
import WebAssetIcon from '@mui/icons-material/WebAsset';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useNavigate } from "react-router-dom";
import ThermostatIcon from '@mui/icons-material/Thermostat';
import PercentIcon from '@mui/icons-material/Percent';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import OnDeviceTrainingIcon from '@mui/icons-material/OnDeviceTraining';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LightModeIcon from '@mui/icons-material/LightMode';

const SignItem = ({ sign }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const adminUser = useSelector((state) => state.user.users.data.list.find(user => user.username == sign.administrator))

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);

  const signColour = "rgb(" + sign.currentColour + ")"

  const getTextColour = (backgroundColor) => {

    const vals = backgroundColor.split(',');
    const brightness = 1;

    var ir = Math.floor((255 - vals[0]) * brightness);
    var ig = Math.floor((255 - vals[1]) * brightness);
    var ib = Math.floor((255 - vals[2]) * brightness);
    return(`rgb(${ir}, ${ig}, ${ib})`);

  }

  const textColour = getTextColour(sign.currentColour)

  useEffect(() => {

    //if there are no users then we can go get it 
    if (!adminUser){
      let username = sign.administrator
      dispatch(getUser({username}));
    }


}, [sign]);

const handleSignClick = () => {
  navigate("/sign/" + sign.id);
};


  return (

    
    <Box 
      width="100%"  
      backgroundColor={colors.primary[400]} 
      padding="15px"
      sx={{ borderRadius:2}}
      onClick={handleSignClick}
    >
      <Box display="flex" alignItems="flex-start" >
        <WebAssetIcon
          sx={{ color: colors.greenAccent[600], fontSize: "40px" }}
        />
          <Box display="flex" flexDirection="column">
            <Typography
              variant="h3"
              fontWeight="bold"
              sx={{ color: colors.grey[100] }}
              ml="10px"
            >
              {sign.name}
            </Typography>
            <Typography

              sx={{ color: colors.grey[100] }}
              ml="10px"
            >
              {sign.id}
            </Typography>
          </Box>

          
      </Box>

      <Box mt="20px">
        <Typography>
          {sign.description}
        </Typography>
      </Box>

      <Box 
        display="flex"
        flexDirection="column"
        mt="20px"
        backgroundColor={colors.primary[300]} 
        padding="15px"
        sx={{ borderRadius:1}}
      >
        <Box
          display = "flex"
          flexDirection="row"
          justifyContent="space-between"
          mb="20px"
        >
        
        <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="row">

          <Box display="flex" justifyContent="space-between" mr="10px">
            <ThermostatIcon/>
            <Typography display="inline">{sign.currentTemp} C</Typography>
          </Box>
        
          <Box display="flex" justifyContent="space-between" mr="10px">
            <PercentIcon/>
            <Typography display="inline">{sign.currentHumidity} %</Typography>
          </Box>

          <Box display="flex" justifyContent="space-between" mr="10px">
            <LightbulbIcon/>
            <Typography display="inline">{sign.currentLight}</Typography>
          </Box>

        </Box>

        <Box mt="10px">

          <Box display="flex"  mr="10px">
            <OnDeviceTrainingIcon/>
            <Typography display="inline"><NiceSignMode>{sign.currentMode}</NiceSignMode></Typography>
          </Box>

          <Box display="flex" flexDirection="row" mt="10px">
            <Box display="flex"  mr="10px">
              <ColorLensIcon/>
              <Box backgroundColor={signColour} p="0px 10px" sx={{ borderRadius:2}} color ={textColour}><Typography display="inline">{sign.currentColour}</Typography></Box>
            </Box>

            <Box display="flex"  mr="10px">
              <LightModeIcon/>
              <Typography display="inline"><NiceSignBrightness>{sign.currentBrightness}</NiceSignBrightness></Typography>
            </Box>
          </Box>
          </Box>
          </Box>

          <Box display="flex" width="120px">
            <AccountTreeIcon/>
            <Typography variant="h6" ml="10px">
              
                <NiceCollection>{sign.collection}</NiceCollection>
              
            </Typography>
          </Box>


      </Box>
      

      <Typography>
        Sign first seen <NiceDate>{sign.createdAt}</NiceDate> and last seen <NiceDate>{sign.lastHeartBeat}</NiceDate>
      </Typography>

        
      </Box>

      {/* <Box 
        display="flex"
        flexDirection="column"
        mt="20px"
        backgroundColor={colors.primary[300]} 
        padding="15px"
        sx={{ borderRadius:1}}
      >
        <Box display="flex">
          <AdminPanelSettingsIcon sx={{ fontSize: "30px" }}/>
          <Typography variant="h4" ml="10px">{adminUser?.firstName} {adminUser?.lastName}</Typography>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          mt="10px"
        >
          {adminUser &&
            <ProfileAvatar user = {adminUser} size="75"/>
          }
          <Box
            display="flex"
            flexDirection="column"
            ml="20px"
          >
            <Typography >{adminUser?.username}</Typography>
            <Typography >{adminUser?.email}</Typography>
            

          </Box>
        </Box>

      </Box> */}


    </Box>
  );
};

export default SignItem;
